// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-reactions {
  position: absolute;
  bottom: -24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 18px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  min-height: 24px;
}

.message-reactions:hover {
  background-color: #e0e0e0;
  border-color: #ccc;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

/* User messages (sent by current user) - positioned on the right */
.message-reactions.user {
  right: 0;
  left: auto;
}

/* Other messages (received) - positioned on the left */
.message-reactions:not(.user) {
  left: 0;
  right: auto;
}

.message-reactions-emojis {
  display: flex;
  align-items: center;
}

.message-reaction-emoji {
  font-size: 16px;
  line-height: 1;
}

.message-reactions-count {
  font-size: 16px;
  color: #333;
  line-height: 1.2;
  display: inline-flex;
  min-width: 18px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/MessageReactions.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,mEAAmE;AACnE;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,uDAAuD;AACvD;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".message-reactions {\n  position: absolute;\n  bottom: -24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 2px 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 18px;\n  background-color: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  min-height: 24px;\n}\n\n.message-reactions:hover {\n  background-color: #e0e0e0;\n  border-color: #ccc;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n/* User messages (sent by current user) - positioned on the right */\n.message-reactions.user {\n  right: 0;\n  left: auto;\n}\n\n/* Other messages (received) - positioned on the left */\n.message-reactions:not(.user) {\n  left: 0;\n  right: auto;\n}\n\n.message-reactions-emojis {\n  display: flex;\n  align-items: center;\n}\n\n.message-reaction-emoji {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.message-reactions-count {\n  font-size: 16px;\n  color: #333;\n  line-height: 1.2;\n  display: inline-flex;\n  min-width: 18px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
